import { render, staticRenderFns } from "./Configs.vue?vue&type=template&id=40641dbb&scoped=true"
import script from "./Configs.vue?vue&type=script&lang=js"
export * from "./Configs.vue?vue&type=script&lang=js"
import style0 from "./Configs.vue?vue&type=style&index=0&id=40641dbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40641dbb",
  null
  
)

export default component.exports